<template>
  <div>
    <b-textarea
      v-model="deactivateData.deactivateComment"
      :error-messages="getErrorMessages(v$.deactivateComment)"
      label="Причина"
      placeholder="Введіть причину"
      @blur="v$.deactivateComment.$touch()"></b-textarea>
    <b-autocomplete
      v-model="deactivateData.actualProtocol"
      :items="protocolList"
      :loading="$loading.isLoading('searchProtocols')"
      clear-on-select
      item-title="name"
      item-value="id"
      label="Актуальний протокол"
      no-filter
      placeholder="обірть протокол"
      return-object
      @update:search="search"></b-autocomplete>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { urlDeactivateProtocol, urlProtocolList } from '@/utils/urls.js'
import axios from '@/plugins/axios'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { handleAsync } from 'best-modules/plugins'
import { getErrorMessages } from '@/utils/helpers.js'
import { debounce } from 'lodash'
import { BTextarea } from 'best-modules/components'

export default {
  name: 'ProtocolDeactivate',
  components: { BTextarea },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const deactivateData = reactive({
      deactivateComment: null,
      actualProtocol: null,
    })
    const rules = {
      deactivateComment: { required },
    }
    const v$ = useVuelidate(rules, deactivateData)

    const protocolList = ref([])
    const search = debounce(event => {
      handleAsync('searchProtocols', () => {
        if (event && event !== deactivateData.actualProtocol?.name) {
          return axios
            .get(urlProtocolList({ filters: { search: event } }))
            .then(res => (protocolList.value = res.data.data))
        } else {
          protocolList.value = [deactivateData.actualProtocol]
        }
      })
    }, 300)

    const submit = () => {
      return handleAsync('deactivateProtocol', () => {
        return axios.patch(
          urlDeactivateProtocol(props.dialog.dialogData.protocolId),
          {
            deactivateComment: deactivateData.deactivateComment,
            actualProtocolId: deactivateData?.actualProtocol?.id || null,
          }
        )
      })
    }

    return {
      deactivateData,
      v$,
      submit,
      protocolList,
      search,
    }
  },
}
</script>
